import axios from "axios";
import { API } from "../config";


class SituacaoJuridicaService {
    novaSituacaoJuridica(situacaoJuridica) {
        return axios.post(API + "/situacao-juridica", situacaoJuridica);
    }

    listarSituacaoJuridica() {
        return axios.get(API + "/situacao-juridica")
    }

    getSituacaoJuridica(id) {
        return axios.get(API + "/situacao-juridica/" + id)
    }
    atualizarSituacaoJuridica(id, situacaoJuridica) {
        return axios.post(API + "/situacao-juridica/" + id, situacaoJuridica);
    }
    inativarSituacaoJuridica(id, situacaoJuridica) {
        return axios.post(API + "/situacao-juridica/" + id + "/inativar", situacaoJuridica);
    }
    reativarSituacaoJuridica(id, situacaoJuridica) {
        return axios.post(API + "/situacao-juridica/" + id + "/reativar", situacaoJuridica);
    }
    pesquisarSituacaoJuridica(descricao, status, tipo) {
        return axios.get(API + "/situacao-juridica/search", {
            params: {
                descricao: descricao !== "" ? descricao : undefined,
                status: status !== "" ? status : undefined,
                tipo: tipo !== "" ? tipo : undefined
            }
        });
    }
}

const instanceSituacaoJuridica= new SituacaoJuridicaService();
export default instanceSituacaoJuridica;